import { VehicleType } from '../../codegen/vehicles';
import { VehicleIcon } from '../icons/VehicleIcon';

type VehicleRepresentationProps = {
  vehicleType?: VehicleType;
  vehicleName?: string;
};

export const VehicleRepresentation = ({
  vehicleType,
  vehicleName,
}: VehicleRepresentationProps) => {
  return (
    <div className="display-flex gap-5 align-items-center">
      {vehicleType && (
        <VehicleIcon
          type={vehicleType}
          className="text-size-18 text-color-dark"
        />
      )}
      <span className="ellipsis-1">{vehicleName}</span>
    </div>
  );
};
